import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enUS from "./locales/en-US.json";
import esMX from "./locales/es-MX.json";

export const supportedLocales = ["es-MX", "en-US"] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export function normalizeLanguage(lng: string): SupportedLocale {
  const lower = lng.toLowerCase();
  if (lower.startsWith("en")) {
    return "en-US";
  }
  if (lower.startsWith("es")) {
    return "es-MX";
  }
  return "en-US";
}

function syncDocumentLang(lng: string) {
  if (typeof document === "undefined") {
    return;
  }
  const resolved = normalizeLanguage(lng);
  document.documentElement.lang = resolved;
  document.title = i18n.t("app.documentTitle", { lng: resolved });
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "es-MX": { translation: esMX },
      "en-US": { translation: enUS },
    },
    fallbackLng: "en-US",
    supportedLngs: [...supportedLocales],
    preload: [...supportedLocales],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["navigator"],
      caches: [],
      convertDetectedLanguage: normalizeLanguage,
    },
  })
  .then(() => {
    syncDocumentLang(i18n.language);
  });

i18n.on("languageChanged", syncDocumentLang);

export default i18n;
